import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'messages'
const verb = 'get'

export default class OspreyMessagesSearchSuggestion extends BaseAction {
    constructor(dataKey) {
        const id = 'c8101a96-5b34-4232-b628-7d4b5934b308'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getSearchSuggestion(params) {
        this.params = Object.assign({
            fields: 'id,name',
            sf: 'name',
            sd: 'asc',
        }, params)

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/messages/messages-search-suggestion.js